import React from "react";
import {BasePaymentSummaryPage} from "./BasePaymentSummaryPage";
import {MerchantSummaryFilter} from "./MerchantSummaryFilter";

export const MerchantPaymentSummaryPage = () => {
    return (
        <BasePaymentSummaryPage
            filtersComponent={MerchantSummaryFilter}
            isBackoffice={false}
        />
    );
}; 